'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _BaseReducer2 = require('./BaseReducer');

var _BaseReducer3 = _interopRequireDefault(_BaseReducer2);

var _qim = require('qim');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatisticsReducer = function (_BaseReducer) {
  (0, _inherits3.default)(StatisticsReducer, _BaseReducer);

  function StatisticsReducer() {
    (0, _classCallCheck3.default)(this, StatisticsReducer);
    return (0, _possibleConstructorReturn3.default)(this, (StatisticsReducer.__proto__ || (0, _getPrototypeOf2.default)(StatisticsReducer)).apply(this, arguments));
  }

  (0, _createClass3.default)(StatisticsReducer, [{
    key: 'addStatsViewerSuccess',
    value: function addStatsViewerSuccess(_ref) {
      var state = _ref.state,
          action = _ref.action;

      return (0, _qim.update)([['statsViewersData', (0, _qim.$merge)((0, _get3.default)(action, ['result', 'data', 0, 'statsViewers']))]], this._mainReducer(state, action));
    }
  }, {
    key: 'deleteStatsViewerSuccess',
    value: function deleteStatsViewerSuccess(_ref2) {
      var state = _ref2.state,
          action = _ref2.action;

      return (0, _qim.update)([['statsViewersData', _qim.$each, function (viewer) {
        return viewer.userEmail === action.email;
      }, _qim.$none]], this._mainReducer(state, action));
    }
  }, {
    key: 'projectsReorder',
    value: function projectsReorder(_ref3) {
      var state = _ref3.state,
          action = _ref3.action;

      return this._reorder({
        orderFieldName: 'projectsOrder',
        activeOrderFieldName: 'projectsActiveOrder',
        action: action,
        state: state
      });
    }
  }, {
    key: 'recipientsReorder',
    value: function recipientsReorder(_ref4) {
      var state = _ref4.state,
          action = _ref4.action;

      return this._reorder({
        orderFieldName: 'recipientsOrder',
        activeOrderFieldName: 'recipientsActiveOrder',
        action: action,
        state: state
      });
    }
  }, {
    key: 'recipientProjectsReorder',
    value: function recipientProjectsReorder(_ref5) {
      var state = _ref5.state,
          action = _ref5.action;

      return this._reorder({
        orderFieldName: 'recipientProjectsOrder',
        activeOrderFieldName: 'recipientProjectsActiveOrder',
        action: action,
        state: state
      });
    }
  }, {
    key: 'coverageRecipientsReorder',
    value: function coverageRecipientsReorder(_ref6) {
      var state = _ref6.state,
          action = _ref6.action;

      return this._reorder({
        orderFieldName: 'coverageRecipientsOrder',
        activeOrderFieldName: 'coverageRecipientsActiveOrder',
        action: action,
        state: state
      });
    }
  }, {
    key: 'projectsFilter',
    value: function projectsFilter(_ref7) {
      var state = _ref7.state,
          action = _ref7.action;

      return (0, _qim.update)([['projectsKw', (0, _qim.$set)(action.kw)], ['myProjectsListPage', (0, _qim.$set)(1)]], this._mainReducer(state, action));
    }
  }, {
    key: 'recipientsFilter',
    value: function recipientsFilter(_ref8) {
      var state = _ref8.state,
          action = _ref8.action;

      return (0, _qim.set)(['recipientsKw'], action.kw, this._mainReducer(state, action));
    }
  }, {
    key: 'setProjectsTab',
    value: function setProjectsTab(_ref9) {
      var state = _ref9.state,
          action = _ref9.action;

      return (0, _qim.set)(['activeProjectsTab'], action.tab, this._mainReducer(state, action));
    }
  }, {
    key: 'setPeriodName',
    value: function setPeriodName(_ref10) {
      var state = _ref10.state,
          action = _ref10.action;

      return (0, _qim.set)(['periodName'], action.periodName, this._mainReducer(state, action));
    }
  }, {
    key: 'setReportDates',
    value: function setReportDates(_ref11) {
      var state = _ref11.state,
          action = _ref11.action;

      return (0, _qim.update)([['startDate', (0, _qim.$set)(action.startDate)], ['endDate', (0, _qim.$set)(action.endDate)]], this._mainReducer(state, action));
    }
  }, {
    key: 'setProjectId',
    value: function setProjectId(_ref12) {
      var state = _ref12.state,
          action = _ref12.action;

      return (0, _qim.set)(['projectId'], action.projectId, this._mainReducer(state, action));
    }
  }, {
    key: 'setRecipientId',
    value: function setRecipientId(_ref13) {
      var state = _ref13.state,
          action = _ref13.action;

      return (0, _qim.set)(['recipientId'], action.recipientId, this._mainReducer(state, action));
    }
  }, {
    key: 'setProjectsListPage',
    value: function setProjectsListPage(_ref14) {
      var state = _ref14.state,
          action = _ref14.action;

      return (0, _qim.set)(['myProjectsListPage'], action.page, this._mainReducer(state, action));
    }
  }]);
  return StatisticsReducer;
}(_BaseReducer3.default);

exports.default = StatisticsReducer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/StatisticsReducer.js
// module id = 2240
// module chunks = 1